import { Component, OnInit, EventEmitter, Output, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ReceiptService } from '../../../../services/receipt.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Rtipopservice } from 'src/app/services/rtipopservice.service';
import { TRUE } from 'sass';
import { debounceTime } from 'rxjs';



interface INewWeight {
  shipmentNo: string;
  weight: number;
}

interface INewWeightError {
  shipmentNo: string;
  errorMsg: string;
}

@Component({
  selector: 'dropoff-awb',
  templateUrl: './dropoff-awb.component.html',
  styleUrls: ['./dropoff-awb.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({
        opacity: 0,
        display: 'none'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class DropOffAwbComponent implements OnChanges  {
  isOpen: boolean = false;
  shipments: any = [];
  isValidAwb: boolean = true;
  shipmentNumber: string;
  isNewCalculationNeeded = false;
  newWeightData: INewWeight[] = [];
  newWeightError: INewWeightError[] = [];
  RTIShipments = [] as any[];
  hasRTIShipment = false;
  Status = [] as any[];
  damagedItems = false;
  isPopupVisible = false;

  @Output() dropoffShipments = new EventEmitter();
  @Output() addToReceipt = new EventEmitter();
  //remove it 
  @Output() addToReceiptRTI = new EventEmitter();
  @Input() changing;
  


 @Output() onRTIShipment = new EventEmitter<{ hasRTIShipment: boolean; RTIShipments: any[] ; damagedItems: boolean; Status: any[] }>();
 @Output() onClickaddToReceiptRTI: EventEmitter<any> = new EventEmitter();

  locationSettings: any[] = JSON.parse(sessionStorage.getItem('branchSettings'));
  branchCurrencyCode: string = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
  isMultiCurrenciesForInbound = false;
  isMultiCurrenciesVisible = false;
  isSpotter: boolean = false;
  isCalculateEnable = true;
  isRowChecked = false;
  isModalVisible: boolean;

  get shipmentsForRtiPopup(): any[] {
    return this.shipments.filter((s) => s?.ProductType === 'RTI');
  }

  constructor(private shipmentDetails: ReceiptService, private toaster: ToastrService, private translate: TranslateService, private popupService: Rtipopservice) {
    this.isSpotter = JSON.parse(sessionStorage.getItem('user')).Network.NetworkId != 1;
  }

handleRTIShipmentFromRTI(event: { hasRTIShipment: boolean; RTIShipments: any[] ; damagedItems: boolean; Status: any[] }) {
  this.onRTIShipment.emit(event);
  this.onAddReceiptClick();
  console.log('handleRTIShipmentFromRTI in DropOffAwbComponent called with event:', event);
}

  openPopup() {
    this.popupService.show();
  }

  serachAwbNumber() {
    this.isNewCalculationNeeded = true;
    this.shipmentNumber = this.shipmentNumber.trim();
    if (this.shipmentNumber != null && this.shipmentNumber != undefined && this.shipmentNumber != "") {
      var shipmentsNumbers = this.shipmentNumber.split('\n');
      shipmentsNumbers = shipmentsNumbers.filter(x => x != "");
      var AWBNumbers = '';
      for (var i = 0; i < shipmentsNumbers.length; i++) {
        AWBNumbers += shipmentsNumbers[i] + (i + 1 < shipmentsNumbers.length ? ',' : '');
      }
      this.shipmentDetails.getDropOffShipmentDetails(JSON.stringify(AWBNumbers), 4, (res) => {
        this.shipmentNumber = '';
        var returnedShipments = res as any[];
        // if (returnedShipments[i].ProductType == 'RTI' ) {
        //   this.shipments =  returnedShipments
        // }
        console.log('returnedShipments', this.shipments);
        
        returnedShipments.forEach((x, index) => {
          
          if (x.ProductType == 'RTI') {
             x.GrossWeight = {
              Value: 0
             }
          }
          
          if (x.PaymentType != null) {
            res[index].ReWeightNeeded = x.PaymentType == 'P' && ["CASH", "CRDT"].includes(x.TypeOfPayment);
          }

          res[index].OldGrossWeight = {
            ...res[index].GrossWeight
          };
          res[index].NewCost = {
            Code: this.branchCurrencyCode,
            Value: 0
          }
        });
        if (res.length == 0) {
          this.toaster.error(shipmentsNumbers.length > 1 ? `${this.translate.instant('pages.createReceiptPage.dropOffAwb.shipmentsNotReady')}` : `${this.translate.instant('pages.createReceiptPage.dropOffAwb.oneShipmentNotReady')}`);
        }
        this.isCalculateEnable = returnedShipments.some((item) => {
          if (item.ProductType == 'RTI') {
            item.ReWeightNeeded = false;
          }
          if (item.ReWeightNeeded && item.ReWeightNeeded == true) {
            return true;
          }

          return false;
        })
        this.updateShipments(returnedShipments);
        this.change();
      }, (err) => { });
    }
    else {
      if (this.shipments.length == 0) {
        this.dropoffShipments.emit(null);
        this.isOpen = false;
      }
      else {
        this.toaster.error(`${this.translate.instant('pages.createReceiptPage.dropOffAwb.validShipmentNumber')}`);
      }
    }
  }

  updateShipments(res: any) {
    var ResShipments = res.filter((x) => { return x.Number != null });
    
    this.isNewCalculationNeeded = res.some((x) => x.ReWeightNeeded == true);
    if (ResShipments.length > 0) {
      for (var i = 0; i < ResShipments.length; i++) {
        var c = this.shipments.filter(x => x.Number === ResShipments[i].Number);
        if (c.length > 0) {
          this.toaster.error(`${this.translate.instant('pages.createReceiptPage.shipmentExsist',{
            shipmentNumber: ResShipments[i].Number
          })}`);
        }
        else {
          this.shipments.push(ResShipments[i]);
        }
      }
    }
  }

  onChangeWeightError(isAll = false, shipmentNo = '', weight = 0) {
    if (isAll) {
      const filterdShipment = this.shipments.filter((x) => x.ReWeightNeeded == true);
      
      filterdShipment.forEach((shipment) => {
        const isExistIndex = this.newWeightData.findIndex((x) => x.shipmentNo == shipment.Number);

        if (isExistIndex > -1 && this.newWeightData[isExistIndex].weight > 0) {
          this.newWeightError = this.newWeightError.filter((x) => x.shipmentNo != shipment.Number);
        } else {
          this.newWeightError.push({
            shipmentNo: shipment.Number,
            errorMsg: 'Required'
          })
        }
      })
    } else {
      const isExistIndex = this.newWeightError.findIndex((x) => x.shipmentNo == shipmentNo);

      if (weight <= 0) {
        if (isExistIndex == -1) {
          this.newWeightError.push({
            shipmentNo: shipmentNo,
            errorMsg: 'Required'
          })
        }
      } else {
        this.newWeightError = this.newWeightError.filter((x) => x.shipmentNo != shipmentNo);
      }
    }
  }

  getNewWeightError(shipmentNo: string) {
    const isExistIndex = this.newWeightError.findIndex((x) => x.shipmentNo == shipmentNo);

    if (isExistIndex > -1) {
      return this.newWeightError[isExistIndex].errorMsg;
    }

    return null;
  }

  onChangeWeight(event: any, shipmentNo: string) {
    const isExistIndex = this.newWeightData.findIndex((x) => x.shipmentNo == shipmentNo);
    let weight = parseFloat(event.target.value);
    if (isNaN(weight)) {
      weight = 0;
    }

    if (isExistIndex > -1) {
      this.newWeightData[isExistIndex].weight = weight;
    } else {
      this.newWeightData.push({
        shipmentNo: shipmentNo,
        weight: weight
      })
    }

    this.onChangeWeightError(false, shipmentNo, weight);
  }

  onCalculateClick() {
    this.onChangeWeightError(true);
    let payload = [];

    this.newWeightData.forEach((item) => {
      const shipment = this.shipments.find((x) => x.Number == item.shipmentNo);

      if (shipment) {
        payload.push({
          Account: {
            Reference: shipment.ShipperId,
            Number: shipment.ShipperAccountNumber,
            Name: shipment.ShipperName,
          },
          ShipmentNo: shipment.Number,
          FromCountryCode: shipment.OriginAddress.CountryCode,
          ToCountryCode: shipment.DestinationAddress.CountryCode,
          Weight: {
            Value: item.weight,
            Unit: shipment.GrossWeight?.Unit,
          },
          ProductType: shipment.ProductType
        })
      }
    })

    this.shipmentDetails.calculateDropOffRate(payload, (res) => {
      if (res && Array.isArray(res)) {
        const anyDetailsFound = res.find((i) => {
           if (i.RateDetails != null) {
              return i;
           }
        });

        this.isNewCalculationNeeded = anyDetailsFound == null;

        this.shipments.forEach((shipment) => {
          const data = res.find((i) => i.ShipmentNo == shipment.Number);
          const newWeight = payload.find((i) => i.ShipmentNo == shipment.Number);
          let newCost = 0, newCurrency = '';

          if (data && data.RateDetails != null) {
            if (newWeight.Weight.Value <= shipment.OldGrossWeight?.Value) {
              if (shipment.TypeOfPayment == 'CASH') {
                newCost = shipment.CashValue.Value;
                newCurrency = shipment.CashValue.Code;
              } else if (shipment.TypeOfPayment == 'CRDT') {
                newCost = 0;
                newCurrency = shipment.CashValue.Code;
              }
            } else {
              if (shipment.TypeOfPayment == 'CASH') {
                newCost = data.RateDetails.TotalAmount;
                newCurrency = data.RateDetails.CurrencyCode;
              } else if (shipment.TypeOfPayment == 'CRDT') {
                newCost = data.RateDetails.TotalAmount - shipment.CashValue.Value;
                newCurrency = data.RateDetails.CurrencyCode;
              }
            }
            shipment.GrossWeight.Value = newWeight.Weight.Value;
            shipment.NewCost = {
              Code: newCurrency,
              Value: newCost
            }
            shipment.RateDetails = data.RateDetails;
          } else if (newWeight) {
            this.toaster.error(`${this.translate.instant('pages.createReceiptPage.dropOffAwb.getRateFailed',{
              shipemntNumber: shipment.Number
            })}`);
          }
        })
      }
    }, (err) => {
      this.isNewCalculationNeeded = true;
    })
  }

  getNewCost(newCost: any) {
    if (newCost && newCost.Code != null && newCost.Value != null) {
      return newCost.Value + " " + newCost.Code;
    }

    return "-"
  }

  onAddReceiptClick() {
    if (this.hasRTIShipment == true) {
      this.isNewCalculationNeeded = false
    }
    if (this.isNewCalculationNeeded == false) {
      this.dropoffShipments.emit(this.shipments);
      this.addToReceipt.emit();
    }
  }

  onAddReceiptRTILogicClick(){
    if (this.isNewCalculationNeeded == false) {
      this.dropoffShipments.emit(this.shipments);
    }  
  }


  handleRTIShipment(event: { hasRTIShipment: boolean; RTIShipments: any[] ; damagedItems: boolean; Status: any[] }) {
  console.log('RTI shipment data received from child:', event);
  this.hasRTIShipment = event.hasRTIShipment;
  this.shipments = event.RTIShipments;
  this.Status = event.Status;
  this.damagedItems = event.damagedItems;

  
}

  onShipmentCheck(AWB : number){
  let currentShipment = this.shipments.find(shipment => shipment.Number == AWB);
  currentShipment.isPrintLabelEnabled = !currentShipment.isPrintLabelEnabled;
  }
  
  doCreateMultipleShipment(shipment: any) {
    let chargesCurrency = [shipment.Shipment.CashOnDelivery.Code, shipment.Shipment.Customs.Code, shipment.Shipment.RatedPrice.Code];
    const currencySet = new Set();
    let retShipments = [];

    chargesCurrency.forEach((chargeCurrency: any) => {
      if (this.checkCurrency(chargeCurrency)) {
        currencySet.add(chargeCurrency);
      }
    });

    chargesCurrency = Array.from(currencySet);

    chargesCurrency.forEach((currency) => {
      let tShipment = JSON.parse(JSON.stringify(shipment));;

      if (this.checkCurrency(shipment.Shipment.CashOnDelivery.Code) && shipment.Shipment.CashOnDelivery.Code !== currency) {
        tShipment.Shipment.CashOnDelivery.Code = '';
        tShipment.Shipment.CashOnDelivery.Value = 0;
        tShipment.Shipment.CODCollectionID = 0;
      }

      if (this.checkCurrency(shipment.Shipment.Customs.Code) && shipment.Shipment.Customs.Code !== currency) {
        tShipment.Shipment.Customs.Code = '';
        tShipment.Shipment.Customs.Value = 0;
        tShipment.Shipment.CustomCollectionID = 0;
      }

      if (this.checkCurrency(shipment.Shipment.RatedPrice.Code) && shipment.Shipment.RatedPrice.Code !== currency) {
        tShipment.Shipment.RatedPrice.Code = '';
        tShipment.Shipment.RatedPrice.Value = 0;
        tShipment.Shipment.CCCollectionID = 0;
      }
      retShipments.push(tShipment);
    });
    return retShipments;
  }

  getCurrency(shipment) {
    if (this.isMultiCurrenciesForInbound) {
      return this.checkCurrency(shipment.Shipment.CashOnDelivery.Code) ? shipment.Shipment.CashOnDelivery.Code : (
        this.checkCurrency(shipment.Shipment.Customs.Code) ? shipment.Shipment.Customs.Code : shipment.Shipment.RatedPrice.Code
      )
    }
    return '';
  }

  checkCurrency(currency: string) {
    return currency != null && currency.trim() != ''
  }

  change() {
    this.isOpen = true;
  }

  fixDecimals(value: any = 0) {
    if (value != 0) {
      value = parseFloat(value).toFixed(2);
      return value;
    }
    else {
      return 0;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true)
        this.isOpen = change;
      this.shipments = [];
      this.shipmentNumber = '';
    }
  }

  calculateTotalCharges(Customs, CashOnDelivery, RatedPrice) {
    var totalCharges = 0;
    if (Customs)
      totalCharges += Customs;
    if (CashOnDelivery)
      totalCharges += CashOnDelivery;
    if (RatedPrice)
      totalCharges += RatedPrice;
    return this.fixDecimals(totalCharges);
  }

  removeShipment(shipment) {
    var index = this.shipments.indexOf(shipment)
    if (index > -1) {
      this.shipments = this.shipments.filter((x) => x?.Number != shipment?.Number);
    }
  }
}
